import React, { useState } from "react";
import ArrowDown from ".//..//..//..//..//assets//images//icons//arrow-down.svg";
import TetellistaItemCal from "./TetellistaItemCal/TetellistaItemCal";

const TetellistaItem = ({ item, index, saveProposalItems2 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const isExpandedHandle = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <div>
      {isExpanded === false ? (
        <div className="w-full grid  grid-cols-[1fr_10rem_10rem_4rem] justify-between bg-[#EAEBEA] border-[1px] border-[#EAEBEA] py-4 px-8 rounded-xl">
          <span>{index === 0 ? "Felpakolás" : `Lepakolás ${index}`}.</span>
          <span className="text-center border-l-2 border-[#8A8A8A]">
            {item?.capacity} m3
          </span>
          <span className="text-center border-l-2 border-[#8A8A8A]">
            {item?.total} EUR
          </span>
          <span className="flex justify-center border-l-2 border-[#8A8A8A]">
            <img
              src={ArrowDown}
              onClick={isExpandedHandle}
              className="w-6 h-6 cursor-pointer"
            />
          </span>
        </div>
      ) : (
        <div className="w-full flex flex-col  bg-[#0655671a] border-[1px] border-secondary-color py-4 px-8 rounded-xl">
          <div className="w-full grid  grid-cols-[1fr_10rem_10rem_4rem]  justify-between pb-6">
            <span>{index === 0 ? "Felpakolás" : `Lepakolás ${index}`}.</span>
            <span className="text-center border-l-2 border-[#8A8A8A]">
              {item?.capacity} m3
            </span>
            <span className="text-center border-l-2 border-[#8A8A8A]">
              {item?.total} EUR
            </span>
            <span className="flex justify-center border-l-2 border-[#8A8A8A]">
              <img
                src={ArrowDown}
                onClick={isExpandedHandle}
                className="w-6 h-6 cursor-pointer"
              />
            </span>
          </div>
          <div>
            <TetellistaItemCal
              saveProposalItems2={saveProposalItems2}
              item={item}
              index={index}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TetellistaItem;
